import Immutable from 'immutable';

import ClassFactory from 'sharedreact/utils/ClassFactory';
import UploadedFile from 'sharedreact/data/UploadedFile';

const Content: {
  status: string,
  files: Immutable.List<UploadedFile>,
  progressId: string | null
} = {
  status: '',
  files: Immutable.List(),
  progressId: null
};

class UploadFileResult extends Immutable.Record(Content) {
  static fromJS (json: object): UploadFileResult {
    return ClassFactory.createFromJson(json, UploadFileResult);
  }

  static get Status (): { [key: string]: string } {
    return {
      OK: 'OK',
      FILES_EXIST: 'FILES_EXIST'
    };
  }
}

export default UploadFileResult;
